<template>
<div class="box">
  <headerComponent ref="header"></headerComponent>
  <section id="hero" class="mt-4" :style="{'minHeight':containerHeight - 5 +'px'}">
    <div class="container">


      <div class="container">
        <div class="row d-flex">
          <div class="col-lg-8 mx-auto text order-1 order-lg-1">
            <h3>{{ this.common.name }}客服中心</h3>
            <div class="mt-5">
              <div class="col-12 mt-2">
                <a class="w-100 primary-btn">邮箱: {{this.common.email}}</a>
              </div>
              <div class="col-12 mt-2">
                <a target="_blank" class="w-100 primary-btn">QQ群：{{this.common.qq}}</a>
              </div>
<!--              <div class="col-12 mt-2">-->
<!--                <a target="_blank" class="w-100 primary-btn">Telegram 客服</a>-->
<!--              </div>-->
              <div class="col-12 mt-2">
                <p class="text-muted mb-1">在线客服工作时间：周一至周五 09:00-18:00，如不在工作时间内可给我们留言，邮件回复。</p>
              </div>

            </div>
          </div>
          <!--                    d-none d-lg-block-->

        </div>
      </div>


    </div>
  </section>
  <footerComponent ref="footer"></footerComponent>
</div>
</template>

<script>
import headerComponent from "@/components/header";
import footerComponent from "@/components/footer";
export default {
  name: "customerPage",
  components:{headerComponent, footerComponent},
  data(){
    return{
      containerHeight:0,
      // link:this.common.getOs()
    }
  },
  mounted() {
    let pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    let headerHeight = this.$refs.header.$el.clientHeight
    let footerHeight = this.$refs.footer.$el.clientHeight
    this.containerHeight = pageHeight - (headerHeight + footerHeight)
  }
}
</script>

<style scoped lang="scss">
p, small {
  color: #5b617c;
  font-family: 'Roboto', sans-serif;
}

.heading-wrapper {
  max-width: 850px;
  margin: 0 auto;
  text-align: center;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #282c47 !important;
}

#hero {
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
  padding: 20px 0 80px 0;
}

#hero h1 {
  font-size: 46px;
  margin-bottom: 30px;
}

#hero p {
  margin-bottom: 20px;
}

.heading-wrapper p {
  font-size: 20px;
}

.primary-btn {
  background-color: #E74C3C;
  color: #ffffff;
  display: inline-block;
  font-size: 10px;
  margin: 5px;
  padding: 14px 30px;
  border-radius: 4px;
}

.info-btn2 {
  background-color: #28a745;
  color: white !important;
  margin: 5px;
  padding: 0.55rem 0;
}

section {
  padding: 80px 0;
}
/*/////////////////////////////////////////
Footer
////////////////////////////////////////*/

#footer {
  background-color: #282c47;
  text-align: center;
  padding: 80px 0 30px 0;
}

#footer h3 {
  color: #ffffff!important;
  margin-bottom: 25px;
}

#footer i {
  font-size: 20px;
  color: #5b617c;
  margin: 0 5px;
}
</style>